<!-- <div class="inner-splash" [class.has-header-bar]="!inIframe"
    [class.hidden1]="(viewModelLoaded && !orchestratorViewModel.actionInProgress) || orchestratorViewModel.documentEnabled">
</div> -->
<div class="inner-splash" [class.has-header-bar]="skipHeader" [class.hidden]="!isVisible"></div>
<div class="loader-content" [class.hidden]="!isVisible" *ngIf="animation || text?.length > 0">
  <div *ngIf="animation" class="loader-animation"></div>
  <div *ngIf="text?.length > 0" class="loader-text" [class.has-loader-animation]="animation">{{text}}</div>
</div>